import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'
import NextRouter from 'next/router'

import { Organization, WebPage } from '@grandvision/analytics'
import {
  DefaultPageProps,
  getAlgoliaConfigFromBloomreach,
  getPageSeo,
  parseJsonLabel,
} from '@grandvision/bloomreach'
import {
  AlgoliaConfigProvider,
  AlgoliaConfigProviderProps,
  fetchAlgoliaConfig,
} from '@grandvision/search'
import { Locales } from '@grandvision/state'

import componentDefinitions from '../../cms/component-definitions'
import Layout from '../../components/Layout'
import { createAlgoliaConfig } from '../../util/algolia'

const { publicRuntimeConfig } = getConfig()

const getPageTypeByName = {
  homepage: 'Home',
  'ofertas-e-campanhas-standard-main-page': 'Campaign',
}

interface Props extends DefaultPageProps {
  algoliaConfig: AlgoliaConfigProviderProps
}

const ContainerPage = ({
  pageModel,
  asPath,
  preview,
  request,
  labels,
  isSolaris,
  algoliaConfig,
}: Props) => {
  if (!pageModel) {
    console.error(`No pageModel found for path: ${asPath}!`)
    return null
  }

  const seoData = getPageSeo(pageModel)

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={{ ...pageModel, labels, request }}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => {
        const content = (
          <Layout pageModel={pageModel} asPath={asPath} isSolaris={isSolaris} preview={preview}>
            {getPageTypeByName[pageModel.page.name] && (
              <WebPage
                url={seoData.canonicalUrl}
                pageType={getPageTypeByName[pageModel.page.name]}
                name={seoData.title}
                description={seoData.description}
              />
            )}
            {getPageTypeByName[pageModel.page.name] === 'Home' &&
              labels &&
              labels.multiopticas &&
              labels.multiopticas.organization && (
                <Organization {...parseJsonLabel(labels.multiopticas.organization)} />
              )}
            <RenderCmsComponent />
          </Layout>
        )

        if (!algoliaConfig.isEnabled) {
          return content
        }

        return (
          <AlgoliaConfigProvider {...algoliaConfig} NextRouter={NextRouter}>
            {content}
          </AlgoliaConfigProvider>
        )
      }}
    </CmsPage>
  )
}

ContainerPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, isSolaris, preview } = query as any

  const algoliaConfig = await fetchAlgoliaConfig({
    ...createAlgoliaConfig(asPath),
    ...getAlgoliaConfigFromBloomreach(pageModel),
    locale: Locales[query.locale],
  })

  return {
    asPath,
    pageModel,
    preview,
    request,
    isSolaris,
    algoliaConfig,
  }
}

export default ContainerPage
